export const SERVER_HOST = "192.168.1.6";
export const SERVER_PORT = "8080";
export const SERVER_HTTP = "http";

export const SERVER_ENDPOINT = {
  authentification: "students/auth",
  me: "students/me",
};
